 const color_bot_divs = document.getElementById('colors-bots-content');
    const color_bot_click = document.getElementById('colors-bot-text');

    color_bot_click.addEventListener('click', () => {
    if (color_bot_divs.style.display === 'block') {
        color_bot_divs.style.display = 'none';
    } else {
        color_bot_divs.style.display = 'block';
    }
    });


 const perfect_bot_divs = document.getElementById('Perfect-fit-bottoms');
    const perfect_bot_click = document.getElementById('Perfect-fit-content-bottoms');

    perfect_bot_click.addEventListener('click', () => {
    if (perfect_bot_divs.style.display === 'block') {
        perfect_bot_divs.style.display = 'none';
    } else {
        perfect_bot_divs.style.display = 'block';
    }
    });

  const modalDetails = document.getElementById("modalPopupDetails");
  const closeButtonDetails = document.querySelector(".close-buttonDetails");
  const openModalButtonDetails = document.getElementById("openModalDetails");

  closeButtonDetails.addEventListener("click", () => {
    modalDetails.style.display = "none";
  });

  window.addEventListener("click", (event) => {
    if (event.target === modalDetails) {
      modalDetails.style.display = "none";
    
    }
  });

  openModalButtonDetails.addEventListener("click", () => {
    modalDetails.style.display = "block";
  });
